import { IcInfo16 } from '@assets/icons/16x16';
import { Box, Button, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { DraggablePanel } from '@components/ui/draggable';
import { FormattedMessage } from 'react-intl';

import { PopupComponentProps, PopupTypeEnum } from '@/types/popup.types';

export default function ConfirmationPopup({
  mapConstraintsRef,
  top,
  left,
  data,
  onClose,
}: Readonly<PopupComponentProps<PopupTypeEnum.CONFIRMATION_POPUP>>) {
  const { title, description, submitLabel, onSubmit, width = 648, height = 270 } = data;
  return (
    <DraggablePanel.Root constraintsRef={mapConstraintsRef} top={top} left={left}>
      <DraggablePanel.Header onClose={onClose}>
        <FormattedMessage id={title} />
      </DraggablePanel.Header>
      <DraggablePanel.Body width={width} height={height}>
        <VStack backgroundColor="neutral.700" width="100%" height="100%" padding={4} gap={4} alignItems="start">
          <Text width="100%" textStyle="lg" whiteSpace="pre-line">
            {description}
          </Text>
          <HStack gap={2}>
            <Icon as={IcInfo16} color="neutral.white" />
            <Text textStyle="md">
              <FormattedMessage id="global.unrecoverableAction" />
            </Text>
          </HStack>
          <HStack width="100%" gap={2} justifyContent="center">
            <Box borderWidth="2px" borderColor="blue.700">
              <Button variant="secondary" onClick={onClose}>
                <FormattedMessage id="global.cancel" />
              </Button>
            </Box>
            <Box borderWidth="2px" borderColor="blue.700">
              <Button onClick={onSubmit}>{submitLabel}</Button>
            </Box>
          </HStack>
        </VStack>
      </DraggablePanel.Body>
    </DraggablePanel.Root>
  );
}
